/* eslint-disable eqeqeq */

import { useState } from "react";
import { useForm } from "@mantine/form";

import {
  Alert,
  Group,
  Modal,
  Select,
  Space,
  Text,
} from "@mantine/core";

import { Button } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

import { collectionGroup, getDocs, getFirestore, query, where, updateDoc, Timestamp } from "firebase/firestore";
import { NotificationMSG } from "../types";





type FormProps = {
  fund: string;
};


const RequestPaymentModal = (props: any) => {

  const opened: boolean = props.opened;
  const setOpened = props.setOpened;
  const [confirming, setConfirming] = useState<boolean>(false);
  const [msg, setMsg] = useState<NotificationMSG | null>(null);

  const db = getFirestore();



  const handleSubmit = async (data: FormProps) => {
    if (data?.fund) {
      const now = new Date();
      let ordersQuery = query(collectionGroup(db, "orders"),
        where("fund.id", "==", data.fund),
        where("tags.orderStatus.code", "==", "waiting_for_collection_date"),
        where("fund.moneyCollectionDate", "<", Timestamp.fromDate(now))
      )

      const ordersSnapshot = await getDocs(ordersQuery);
      if (!ordersSnapshot.docs.length) {
        return setMsg({ type: "error", message: "no orders waiting for payment found" });
      }

      setMsg({ type: "success", message: `found ${ordersSnapshot.docs.length} orders waiting for payment, updating` });

      let successCount = 0;
      let failureCount = 0;

      for (const orderDoc of ordersSnapshot.docs) {
        try {
          await updateDoc(orderDoc.ref, {
            "lastPaymentRequestDate": Timestamp.fromDate(now),
          });
          successCount += 1;
        } catch (error) {
          console.error("Failed to update order document", orderDoc.id, error);
          failureCount += 1;
        }
      }

      if (failureCount > 0) {
        setMsg({
          type: "error",
          message: `Updated ${successCount} orders successfully, but ${failureCount} order(s) failed to update. Check console for details.`,
        });
      } else {
        setMsg({
          type: "success",
          message: `Successfully updated ${successCount} orders waiting for payment.`,
        });
      }
    } else {
      setMsg({ type: "error", message: "Fund not selected" });
    }

  }
  const form = useForm<FormProps>({

  });

  return (
    <>
      <Modal
        opened={opened}
        onClose={() => {
          setMsg(null);
          setOpened(false);
          setConfirming(false)
        }}
        title="Collect Payment for fund"
      >

        <Text>
          This updates all the orders that have the status of  "Waiting for collection date" to "Need Slip", requesting the client to pay for their order if not already paid
        </Text>

        <Space h="xl" />

        <form
          onSubmit={form.onSubmit(async (values) => {
            console.log(values);



            // setConfirmDialogError(null);
            setMsg(null);
            // props?.setPending(true)

            setConfirming(true);
            console.log("yeaaa we are here");

            try {

              await handleSubmit(values)

              // setIsError(true);
              // setMsg({ type: "success", message: "Updating orders statuses to " });
            } catch (error: any) {
              // setIsError(true);
              console.log(error);
              // setMsg(error.message);
              // setMsg({type:"error",msg:});
              setMsg({ type: "error", message: error.message });


              // setConfirmDialogError(error.message);
            }

            setConfirming(false);

          })}
        >





          <Select
            {...form.getInputProps("fund")}
            label="Select fund"
            placeholder="choose fund"
            data={[

              { value: '3007', label: 'UK Real Estate Fund VI LP' },
              { value: '50001', label: 'Trade Finance' },

            ]}
          />



          <Space h="xl" />
          <Group>
            <Button color="grape" type="submit" loading={confirming}>
              Request Payment
            </Button>
          </Group>

          <Space h="xl" />

          {msg && (
            <Alert
              icon={<IconAlertCircle size={16} />}
              color={msg.type == "success" ? "green" : msg.type == "info" ? "blue" : "red"}
              title={msg.type == "success" ? "Success" : msg.type == "info" ? "Info" : "Failure"}
            >


              {msg.message}
              <br />


            </Alert>
          )}

        </form>
      </Modal >
    </>
  );
}

export default RequestPaymentModal;